import { useMutation } from '@tanstack/react-query';
import { acceptInvite } from '@api/invites';

export const useInviteAccept = () => {
  return useMutation({
    mutationFn: acceptInvite,
  });
};
